// extracted by mini-css-extract-plugin
export default {"wrapper":"AccionaAlert_wrapper__OWxgF"};